<template>
    <div class="goh-legacy-dot-bar">
        <i
            v-for="n in max" :data-index="n"
            :key="`dot-${n}-${active.get(n)}`"
            :class="getIconClass(n)"
        />
    </div>
</template>

<script>
import { Vue, Options } from "vue-class-component";
import { limitedAccountMixin } from '@gekophaken/common';


export default Options({
    name: 'goh-legacy-dot-bar',
    mixins: [limitedAccountMixin],
    props: {
        value: { type: Number, default: 0 },
        max: { type: Number, default: 5 },
        animate: { type: Boolean, default: true },
        activeIconClass: { type: [String, Object], default: 'ph-fill ph-circle' },
        inactiveIconClass: { type: [String, Object], default: 'ph ph-circle' }
    }
})(
    class LegacyDotBar extends Vue {

        getIconClass(n) {

            const isActive = this.active.get(n);

            return [
                isActive ? this.activeIconClass : this.inactiveIconClass,
                isActive ? 'icon--active' : 'icon--inactive'
            ];
        }

        get active() {

            const active = new Map();

            for(let i = 1; i <= this.max; i++) {

                active.set(i, i <= this.value);
            }

            return active;
        }
    }
)

</script>
<style lang="scss">
:root {
    --goh-legacy-dot-bar-active-icon-color: var(--ui-color-primary);
    --goh-legacy-dot-bar-inactive-icon-color: var(--ui-color-primary);
    --goh-legacy-dot-bar-icon-size: 1.6rem;
}

.goh-legacy-dot-bar {
    display: flex;
    gap: 0.1rem;
    align-items: center;
    font-size: var(--goh-legacy-dot-bar-icon-size);

    .icon--active {
        color: var(--goh-legacy-dot-bar-active-icon-color);
    }

    .icon--inactive {
        color: var(--goh-legacy-dot-bar-inactive-icon-color);
    }
}
</style>
